import React from "react";
import styles from "../styles/platos.module.css";
import { FaMagnifyingGlass } from "react-icons/fa6";
import PlatoItem from "./PlatoItem";

export default function PlatosList({ list, isOpen, onToggle, onEdit, onDelete }) {
    return (
        <section className={styles.section}>
            <div className={styles.stack}>
                {list.length === 0 ? (
                    <div className={`${styles.card} ${styles.soft} ${styles.empty}`}>
                        <h4 style={{ margin: 0 }}><FaMagnifyingGlass style={{ fontSize: "30px" }} /></h4>
                        <p className={styles.muted}>Prueba con otro término de búsqueda o crea un plato.</p>
                    </div>
                ) : (
                    list.map((p) => (
                        <PlatoItem
                            key={p.id}
                            plato={p}
                            open={isOpen(p.id)}
                            onToggle={() => onToggle(p.id)}
                            onEdit={() => onEdit(p)}
                            onDelete={() => onDelete(p.id)}
                        />
                    ))
                )}
            </div>
        </section>
    );
}
